module.exports = __webpack_public_path__ + "img/image-thumb-7.b8a0da3e.jpg";